<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-velda-articles-subnav></app-velda-articles-subnav>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>Sets overview</h1>
            <span
                ngbDropdown
                class="dropdown m-l-2">
                <button
                    ngbDropdownToggle
                    class="button button--select">
                    Options
                </button>
                <span
                    ngbDropdownMenu
                    class="dropdown-menu-right">
                    <form>
                        <span
                            *appIsPermitted="{
                                module: 'VELDA_ARTICLES',
                                operator: 'AND',
                                actions: ['CREATE']
                            }">
                            <label
                                ngbDropdownItem
                                (click)="openAddSetQueryModal()"
                                *ngIf="!this.query && !this.loading"
                                >Add sets query</label
                            >
                        </span>
                        <span
                            *appIsPermitted="{
                                module: 'VELDA_ARTICLES',
                                operator: 'AND',
                                actions: ['EDIT']
                            }">
                            <label
                                ngbDropdownItem
                                (click)="openEditSetQueryModal()"
                                *ngIf="this.query && !this.loading"
                                >Edit sets query</label
                            >
                        </span>
                        <span
                            *appIsPermitted="{
                                module: 'VELDA_ARTICLES',
                                operator: 'AND',
                                actions: ['DELETE']
                            }">
                            <label
                                ngbDropdownItem
                                (click)="openDeleteSetQueryModal()"
                                *ngIf="this.query && !this.loading"
                                >Delete sets query</label
                            >
                        </span>
                    </form>
                </span>
            </span>
        </div>

        <span
            *appIsPermitted="{
                module: 'VELDA_ARTICLES',
                operator: 'AND',
                actions: ['READ']
            }">
            <app-velda-articles-sets-list *ngIf="this.query && !this.loading"></app-velda-articles-sets-list>
        </span>

        <div *ngIf="!this.query && !this.loading">
            <app-message-empty
                [title]="'No Query set...'"
                [icon]="'../../assets/img/open-box.png'"></app-message-empty>
        </div>

        <div *ngIf="this.loading">
            <app-loading-message></app-loading-message>
        </div>
    </app-content>
</app-app-holder>
